import folderStore, { Folder } from 'owa-folders';
import { actionNames, EmptyFolderStoreUpdate } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';

export default function emptyFolderStitch() {
    subscribe<EmptyFolderStoreUpdate>(
        actionNames.EmptyFolderStoreUpdate,
        (folderToEmpty: Folder, clientLastSyncTime: Date, deletedItemsFolderId: string) => {
            const deletedItemsFolder = folderStore.folderTable.get(deletedItemsFolderId);

            // We update the unread count of the delete folder optimistically too
            // The content of the table will be cleared using the emptyFolderStitch to talk across packages
            deletedItemsFolder.UnreadCount += folderToEmpty.UnreadCount;
            folderToEmpty.UnreadCount = 0;
        }
    );
}
